module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _vm._v("Jewish Studies in the 21"), _c('sup', [_vm._v("st")]), _vm._v(" Century")]), _vm._v(" "), _c('p', {
    staticClass: "seraft"
  }, [_vm._v("Frederick E. Greenspahn is Gimelstob Eminent Scholar of Judaic Studies at Florida Atlantic University. Greenspahn is General Editor of the Jewish Studies in the 21st Century Series, and is the volume editor of the following books in the series:")]), _vm._v(" "), _c('p', {
    staticClass: "seraft"
  }, [_c('i', [_vm._v("The Hebrew Bible: New Insights and Scholarship")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Women and Judaism: New Insights and Scholarship")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Jewish Mysticism and Kabbalah: New Insights and Scholarship")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Contemporary Israel: New Insights and Scholarship")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Early Judaism: New Insights and Scholarship")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-167fc3e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/greenspahnEarly-0003.vue
// module id = 60
// module chunks = 0